import { MoonstarEdit } from '../Moonstar/MoonstarEdit';
import { MoonstarEditForm } from '../Moonstar/MoonstarEditForm';
import { JourneyInputs } from './JourneyInputs';

export const JourneysEdit = () => {
  return (
    <MoonstarEdit redirect="list">
      <MoonstarEditForm className="max-w-none">
        <JourneyInputs isEdit />
      </MoonstarEditForm>
    </MoonstarEdit>
  );
};
